module.exports = __webpack_public_path__ + "img/count-symbol-two.8f934f28.png";